/**
 * Object containing the section IDs used in the HomePage component
 */
export const Sections = {
  home: 'home',
  features: 'features',
  ownership: 'ownership',
  experience: 'experience',
  socials: 'socials',
  signup: 'signup'
};

export default Sections;
